import PropTypes from "prop-types";
import styles from "./ProductSponsorLabel.scss";

function ProductSponsorLabel({ labelText }) {
  return <span className={styles.productSponsorLabel}>{labelText}</span>;
}

export default ProductSponsorLabel;

ProductSponsorLabel.propTypes = {
  labelText: PropTypes.string.isRequired,
};
